import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["tag", "font", "family", "responsive", "weight", "align", "hyphens", "color", "fill", "block", "flexbox", "decoration", "whiteSpace", "transform", "wrap", "shadow", "dropShadow", "className", "children", "ellipsis"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import React from 'react';
const DixuText = _ref => {
  let {
      tag,
      font,
      family,
      responsive,
      weight,
      align,
      hyphens,
      color,
      fill,
      block,
      flexbox,
      decoration,
      whiteSpace,
      transform,
      wrap,
      shadow,
      dropShadow,
      className,
      children,
      ellipsis
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const Tag = tag;
  const classes = classNames('dixu-text', {
    'dixu-text--hyphens': hyphens,
    'dixu-text--block': block,
    'dixu-text--flexbox': flexbox,
    'dixu-text--wrap': wrap,
    'dixu-text--ellipsis': ellipsis,
    [`font-${family}-${font}`]: !responsive && family && font,
    [`responsive-font-${family}-${font}`]: responsive && family && font,
    [`dixu-text--weight-${weight}`]: weight,
    [`dixu-text--align-${align}`]: align,
    [`dixu-text--decoration-${decoration}`]: decoration,
    [`dixu-text--white-space-${whiteSpace}`]: whiteSpace,
    [`dixu-text--transform-${transform}`]: transform,
    [`color-${color}`]: color,
    [`fill-${fill || color}`]: fill || color,
    [`text-shadow-${shadow}`]: shadow,
    [`drop-shadow-${dropShadow}`]: dropShadow
  }, className);
  return /*#__PURE__*/React.createElement(Tag, _objectSpread({
    className: classes
  }, rest), children);
};
DixuText.defaultProps = {
  tag: 'span',
  weight: undefined,
  align: undefined,
  hyphens: false,
  color: undefined,
  fill: undefined,
  font: undefined,
  family: 'quicksand',
  responsive: false,
  block: false,
  flexbox: false,
  wrap: false,
  decoration: undefined,
  whiteSpace: undefined,
  shadow: undefined,
  dropShadow: undefined,
  transform: undefined,
  ellipsis: undefined
};
export default DixuText;